import { render, staticRenderFns } from "./tabla-movimientos-academicos.vue?vue&type=template&id=9f274bd4&scoped=true&"
import script from "./tabla-movimientos-academicos.component.ts?vue&type=script&lang=ts&"
export * from "./tabla-movimientos-academicos.component.ts?vue&type=script&lang=ts&"
import style0 from "./tabla-movimientos-academicos.vue?vue&type=style&index=0&id=9f274bd4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f274bd4",
  null
  
)

export default component.exports